const serviceType = [
    {
        "ID": 1,
        "name": "Standard Shipment"
    },{
        "ID":2,
        "name": "USA Eco"
    }
];
export default serviceType;
